import { MenuItemOption } from 'ui/menu/types';

export const INITIAL_DISPLAY_MAX_COUNT = 3;
export const MAX_DISPLAY_COUNT = 10;

export enum LaunchpadFilter {
  ACTION_TYPE = 'ActionType',
  RESOURCE_TYPE = 'ResourceType',
}

export const LAUNCHPAD_TEST_IDS = {
  MODULE: 'launchpad-module',
  CONTENT: 'launchpad-content',
  HEADER: 'launchpad-header',
};

export const BASE_LAUNCHPAD_FILTER_OPTIONS: MenuItemOption[] = [
  {
    id: LaunchpadFilter.ACTION_TYPE,
    isSelectMenu: true,
    label: 'Action type',
    options: [], // these are added dynamically
  },
  {
    id: LaunchpadFilter.RESOURCE_TYPE,
    isSelectMenu: true,
    label: 'Resource type',
    options: [], // these are added dynamically
  },
];
